export default __webpack_public_path__ + "static/media/rt-1.077e2eb7.svg";